import React, { useState } from 'react';
import { TbX } from 'react-icons/tb';

type Picture = {
  id: string;
  sizes: {
    thumbnail?: { url: string };
    full?: { url: string };
  };
};

type OpenableImageProps = {
  picture: Picture[] | any;
  className?: string;
  height: number;
  width: number;
};

const OpenableImage: React.FC<OpenableImageProps> = ({ picture, className, height, width }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => setIsOpen(false);

  return (
    <>
      <button onClick={() => handleOpen()} className="w-full relative group">
        <div className="absolute inset-0 m-0 h-full w-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-transparent ">
          <div className=" absolute inset-0 h-full w-full bg-gradient-to-t rounded-xl from-black/90 via-black/0" />
        </div>
        <div className="absolute bottom-3 w-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-white font-medium px-2 text-sm">Cliquez pour agrandir</p>
        </div>
        <img draggable={false} src={picture ?? ''} alt="" height={height} width={width} className={className || 'w-full h-full'} />
      </button>
      {isOpen && (
        <>
          <button onClick={handleClose} className="fixed inset-0 bg-black/90 backdrop-blur-sm hover:cursor-default flex items-center justify-center z-50">
            <button className="absolute top-10 right-10 text-white text-2xl md:text-3xl hover:text-primary duration-200 ease-in-out border p-1 rounded-xl hover:bg-black hover:border-black">
              <TbX />
            </button>

            <img draggable={false} src={picture ?? ''} alt="" className="w-[60vh] max-h-[90vh] object-contain rounded-lg" />
          </button>
        </>
      )}
    </>
  );
};

export default OpenableImage;
